import React, { useEffect, useState } from "react";
import { Typography, FormControlLabel, FormControl, TextField, RadioGroup, Radio, FormGroup } from '@mui/material';
import ModalFooter from "../../../Modal/ModalFooter/ModalFooter";

export default function StepOne(props) {
    const [buttons, setButtons] = useState(
        [
            {
                'function': props.prev,
                'text': 'Précedent',
                'disabled': false,
                'color': 'error'
            },
            {
                'function': props.next,
                'text': 'Suivant',
                'disabled': true,
                'color': 'success'
            }
        ]);

    useEffect(() => {
        if (props.datas.entite) {
            buttons[1].disabled = false;
        } else {
            buttons[1].disabled = true;
        }
        setButtons([...buttons]);
    }, [props.datas]);

    function handleChange(e) {
        let datas = Object.assign({}, props.datas);
        datas[e.target.name] = e.target.value;
        props.handleChange(datas);
    }

    return (
        <>
            <Typography id="modal-modal-description" variant="p">
                Vous êtes ?
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <FormControl component="fieldset">
                    <RadioGroup
                        defaultValue={props.datas.entite}
                        name="radio-buttons-group">
                        <FormControlLabel
                            value="Une entreprise"
                            control={<Radio name='entite'
                                onChange={(e) => handleChange(e)} />}
                            label="Une entreprise" />
                        <FormControlLabel
                            value="Un particulié"
                            control={
                                <Radio name='entite'
                                    onChange={(e) => handleChange(e)} />}
                            label="Un particulié" />
                    </RadioGroup>
                </FormControl>
                <TextField
                    id="outlined-multiline-static"
                    label="Autres : Veuillez préciser"
                    name='entite'
                    multiline
                    rows={3}
                    sx={{ width: '100%' }}
                    onChange={(e) => handleChange(e)}
                />
            </Typography>
            <ModalFooter buttons={buttons} />
        </>
    )
}